<template>
    <rkm-overlay>
        <rkm-layout-body :title="id ? 'Edição de procedimento individualizado' : 'Cadastro de procedimento individualizado'">
            <template v-slot:actions>
                <rkm-button
                    @click="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>
                
                <rkm-button
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>
        
            <rkm-layout-content>
                <Form
                    :id="id"
                    @save="handleSave"
                    ref="Form"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/bpa/procedimento-individualizado/components/lancamento/Form'

export default {
    components: { Form },
    methods: {
        handleExit() {
            this.$router.push('/bpa/procedimento-individualizado/index')
        },
        handleSave() {
            this.handleExit()
        },
    },
    props: {
        id: { type: Number, default: null }
    },
}
</script>